//! if flag="", return, else invoke the request, post request put a dependency and flag="" at first time render to prevent invoking the request at the first time render and make useEffect listen to the next change in dependency which will happen when the form is submitted, whereas if useEffect rendered the first time without a dependency it won't listen to the dependency changes and cannot add the dependency to it after the first render
import axios from "axios";
import { useEffect, useState } from "react";
import { useAuthDispatch, useAuthState } from "../GlobalContext.jsx";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
function useAxios(
  api,
  method,
  flag = "",
  dependency = "",
  body = "",
  showToasts,
  dependency2
) {
  const AuthState = useAuthState();
  const AuthDispatch = useAuthDispatch();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  async function fetchData() {
    setLoading(true);

    const options = {
      url: api,
      method: method,
      headers: {
        Authorization: `Bearer ${
          AuthState?.userData?.student_token || AuthState?.userData?.admin_token
        }`,
        //Authorization: `Bearer 37|zYs2BDqeMDjvczVd3EqEz1oKFpaU6Fy1U0ux0BwU`,
        "Content-Type": "multipart/form-data",
      },
      data: body,
    };
    try {
      //axios.defaults.withCredentials=true;

      const res = await axios(options);
      const axiosData = await res.data;
      if (axiosData.status === false) {
        showToasts && toast.error(axiosData.message);
        setError(axiosData.message);
        setData(null);
      } else {
        setData(axiosData);
        setError(null);
        showToasts && toast.success(axiosData.message);
      }
      setLoading(false);
    } catch (axiosError) {
      setError(axiosError);
      setLoading(false);
      showToasts &&
        toast.error(
          (
            <div className="flex flex-col gap-4 ">
              {axiosError?.response?.data?.errors ? (
                Object.values(axiosError?.response?.data?.errors).map(
                  (error, i) => (
                    <div key={i}>
                      {error.map((i, index) => (
                        <p key={index}>{i}</p>
                      ))}
                    </div>
                  )
                )
              ) : (
                <p>{axiosError?.response?.data?.message}</p>
              )}
            </div>
          ) || "An error occurred while loading data"
        );

      if (axiosError.response.status === 401) {
        localStorage.removeItem("userData");
        AuthDispatch({ type: "setUserData", payload: null });
        if (pathname.startsWith("/admin")) {
          navigate("/admin/signin");
        } else {
          navigate("/signin");
        }
      }
    }
  }
  useEffect(() => {
    if (flag === "" || flag === undefined || flag === false) {
      setLoading(false);
      return;
    }
    fetchData();
  }, [dependency, dependency2]);

  return [data, error, loading];
}

export default useAxios;
